import asyncContainer from '../containers/asyncContainer';
import Typeahead from './Typeahead.react';
export default asyncContainer(Typeahead);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/components/AsyncTypeahead.react.js
// module id = 1003
// module chunks = 31